/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.224.1-v202611051432-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqRequestsApiClass {
 
   constructor() {}

  /**
   * @summary Cancel all requests
  */
  public cancelAllRequests(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/requests/all`;
    const urlTemplate = `${baseUrl}/requests/all`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Cancel all requests made by the invoking user
  */
  public cancelMyRequests(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/requests/me`;
    const urlTemplate = `${baseUrl}/requests/me`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Cancel all requests made by the invoking user for a specific session
   * @param {string} sessionId - ID of the current session
  */
  public cancelMyRequestsBySessionId(
    {
      sessionId
    } : {
      sessionId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (sessionId === null || sessionId === undefined) {
      throw new Error("'sessionId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/requests/me/${encodeURIComponent(String(sessionId))}`
      .replace('{sessionId}', encodeURIComponent(String(sessionId)));
    const urlTemplate = `${baseUrl}/requests/me/{sessionId}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Cancel a request
   * @param {string} requestId - ID of the request to cancel
  */
  public cancelRequest(
    {
      requestId
    } : {
      requestId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (requestId === null || requestId === undefined) {
      throw new Error("'requestId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/requests/${encodeURIComponent(String(requestId))}`
      .replace('{requestId}', encodeURIComponent(String(requestId)));
    const urlTemplate = `${baseUrl}/requests/{requestId}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Cancel multiple requests, optionally filtering by a user and/or datasource. If you don't specify any filters, all of the requests currently running in Seeq will be cancelled. If you specify multiple filters, only requests matching all filters will be cancelled.
   * @param {string} [userId] - userId
   * @param {string} [datasourceClass] - datasourceClass
   * @param {string} [datasourceId] - datasourceId
   * @param {string} [dataId] - dataId
  */
  public cancelRequests(
    {
      userId,
      datasourceClass,
      datasourceId,
      dataId
    } : {
      userId?: string,
      datasourceClass?: string,
      datasourceId?: string,
      dataId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/requests`;
    const urlTemplate = `${baseUrl}/requests`;

    const queryParams = {
      ['userId']: userId,      ['datasourceClass']: datasourceClass,      ['datasourceId']: datasourceId,      ['dataId']: dataId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get progress information for the request identified by the supplied ID
   * @param {string} requestId - ID of the request for which to retrieve progress information
  */
  public getRequest(
    {
      requestId
    } : {
      requestId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (requestId === null || requestId === undefined) {
      throw new Error("'requestId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/requests/${encodeURIComponent(String(requestId))}`
      .replace('{requestId}', encodeURIComponent(String(requestId)));
    const urlTemplate = `${baseUrl}/requests/{requestId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.GetRequestOutputV1>;
  }

  /**
   * @summary Get the collection of requests
   * @param {number} [limit=250] - The maximum number of requests that will be returned
  */
  public getRequests(
    {
      limit
    } : {
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/requests`;
    const urlTemplate = `${baseUrl}/requests`;

    const queryParams = {
      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetRequestsOutputV1>;
  }

  /**
   * @summary Restart a request, sending it to the back of the line
   * @param {string} requestId - ID of the request to restart
  */
  public restartRequest(
    {
      requestId
    } : {
      requestId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (requestId === null || requestId === undefined) {
      throw new Error("'requestId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/requests/${encodeURIComponent(String(requestId))}/restart`
      .replace('{requestId}', encodeURIComponent(String(requestId)));
    const urlTemplate = `${baseUrl}/requests/{requestId}/restart`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

}


export const sqRequestsApi = new sqRequestsApiClass();

export type sqRequestsApiEndpoints = {
  'cancelAllRequests': {
    method: 'delete';
    path: '/requests/all';
    response: models.StatusMessageBase;
  };
  'cancelMyRequests': {
    method: 'delete';
    path: '/requests/me';
    response: models.StatusMessageBase;
  };
  'cancelMyRequestsBySessionId': {
    method: 'delete';
    path: '/requests/me/${encodeURIComponent(String(sessionId))}';
    response: models.StatusMessageBase;
  };
  'cancelRequest': {
    method: 'delete';
    path: '/requests/${encodeURIComponent(String(requestId))}';
    response: models.StatusMessageBase;
  };
  'cancelRequests': {
    method: 'delete';
    path: '/requests';
    response: models.StatusMessageBase;
  };
  'getRequest': {
    method: 'get';
    path: '/requests/${encodeURIComponent(String(requestId))}';
    response: models.GetRequestOutputV1;
  };
  'getRequests': {
    method: 'get';
    path: '/requests';
    response: models.GetRequestsOutputV1;
  };
  'restartRequest': {
    method: 'post';
    path: '/requests/${encodeURIComponent(String(requestId))}/restart';
    response: models.StatusMessageBase;
  };
};

type ApiCancelAllRequestsResponse = models.StatusMessageBase;
type ApicancelAllRequestsMutationParams = Parameters<typeof sqRequestsApi.cancelAllRequests> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqRequestsApi.cancelAllRequests>;

export function useApiCancelAllRequestsMutation(
  options?: Omit<UseMutationOptions<ApiCancelAllRequestsResponse, AxiosError<SeeqErrorData>,
    ApicancelAllRequestsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCancelAllRequestsResponse, AxiosError<SeeqErrorData>,
  ApicancelAllRequestsMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: () => sqRequestsApi.cancelAllRequests(resolvedOverrides).then((response) => response.data),
    
    ...mutationOptions,
  });
}
type ApiCancelMyRequestsResponse = models.StatusMessageBase;
type ApicancelMyRequestsMutationParams = Parameters<typeof sqRequestsApi.cancelMyRequests> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqRequestsApi.cancelMyRequests>;

export function useApiCancelMyRequestsMutation(
  options?: Omit<UseMutationOptions<ApiCancelMyRequestsResponse, AxiosError<SeeqErrorData>,
    ApicancelMyRequestsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCancelMyRequestsResponse, AxiosError<SeeqErrorData>,
  ApicancelMyRequestsMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: () => sqRequestsApi.cancelMyRequests(resolvedOverrides).then((response) => response.data),
    
    ...mutationOptions,
  });
}
type ApiCancelMyRequestsBySessionIdResponse = models.StatusMessageBase;
type ApicancelMyRequestsBySessionIdMutationParams = Parameters<typeof sqRequestsApi.cancelMyRequestsBySessionId> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqRequestsApi.cancelMyRequestsBySessionId>;

export function useApiCancelMyRequestsBySessionIdMutation(
  options?: Omit<UseMutationOptions<ApiCancelMyRequestsBySessionIdResponse, AxiosError<SeeqErrorData>,
    ApicancelMyRequestsBySessionIdMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCancelMyRequestsBySessionIdResponse, AxiosError<SeeqErrorData>,
  ApicancelMyRequestsBySessionIdMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApicancelMyRequestsBySessionIdMutationParams) =>
      sqRequestsApi.cancelMyRequestsBySessionId(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCancelRequestResponse = models.StatusMessageBase;
type ApicancelRequestMutationParams = Parameters<typeof sqRequestsApi.cancelRequest> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqRequestsApi.cancelRequest>;

export function useApiCancelRequestMutation(
  options?: Omit<UseMutationOptions<ApiCancelRequestResponse, AxiosError<SeeqErrorData>,
    ApicancelRequestMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCancelRequestResponse, AxiosError<SeeqErrorData>,
  ApicancelRequestMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApicancelRequestMutationParams) =>
      sqRequestsApi.cancelRequest(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCancelRequestsResponse = models.StatusMessageBase;
type ApicancelRequestsMutationParams = Parameters<typeof sqRequestsApi.cancelRequests> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqRequestsApi.cancelRequests>;

export function useApiCancelRequestsMutation(
  options?: Omit<UseMutationOptions<ApiCancelRequestsResponse, AxiosError<SeeqErrorData>,
    ApicancelRequestsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCancelRequestsResponse, AxiosError<SeeqErrorData>,
  ApicancelRequestsMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApicancelRequestsMutationParams) =>
      sqRequestsApi.cancelRequests(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetRequestResponse = models.GetRequestOutputV1;
export function GetRequestQueryKey(
  params: Parameters<typeof sqRequestsApi.getRequest>[0],
) {
  return ['sqRequestsApi', 'getRequest', params] as const;
}

export function useApiGetRequestQuery(
  params: Parameters<typeof sqRequestsApi.getRequest>[0],
  options?: Omit<UseQueryOptions<ApiGetRequestResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetRequestResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetRequestQueryKey(params),
    queryFn: () =>
      sqRequestsApi.getRequest(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetRequestsResponse = models.GetRequestsOutputV1;
export function GetRequestsQueryKey(
  params: Parameters<typeof sqRequestsApi.getRequests>[0],
) {
  return ['sqRequestsApi', 'getRequests', params] as const;
}

export function useApiGetRequestsQuery(
  params: Parameters<typeof sqRequestsApi.getRequests>[0],
  options?: Omit<UseQueryOptions<ApiGetRequestsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetRequestsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetRequestsQueryKey(params),
    queryFn: () =>
      sqRequestsApi.getRequests(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiRestartRequestResponse = models.StatusMessageBase;
type ApirestartRequestMutationParams = Parameters<typeof sqRequestsApi.restartRequest> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqRequestsApi.restartRequest>;

export function useApiRestartRequestMutation(
  options?: Omit<UseMutationOptions<ApiRestartRequestResponse, AxiosError<SeeqErrorData>,
    ApirestartRequestMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiRestartRequestResponse, AxiosError<SeeqErrorData>,
  ApirestartRequestMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApirestartRequestMutationParams) =>
      sqRequestsApi.restartRequest(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
